import React from 'react';
import styles from './WarningMessages.module.scss';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CountUp from 'react-countup';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Divider from '@mui/material/Divider';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';

const WarningMessages = () => (
  <div className={styles.WarningMessages} data-testid="WarningMessages">
     <Card sx={{ padding: 0, boxShadow: 0 }} >
                          <CardHeader sx={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 1, }} action={
                              <IconButton aria-label="settings" color='primary' sx={{ marginRight: 1, }} >
                                  {/* <SettingsSuggestIcon /> */}
                              </IconButton>
                          }
                              title="Warning & messages" />
                          <Divider />
                          <CardContent sx={{ paddingLeft: 0, paddingRight: 0, }}>


                              <Stack spacing={1} direction="row" useFlexGap flexWrap="wrap">

                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'danger.light', color: 'danger.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          Available Subcontractors
                                      </Typography>
                                      <Typography variant="h5" component="h1"    >
                                          <CountUp end={500} duration={1} enableScrollSpy />
                                      </Typography>
                                  </Box>
                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'danger.light', color: 'danger.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          Last miles agent
                                      </Typography>
                                      <Typography variant="h5" component="h1"   >
                                          <CountUp end={500} duration={1} enableScrollSpy />
                                      </Typography>
                                  </Box>
                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'danger.light', color: 'danger.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          First mile agent
                                      </Typography>
                                      <Typography variant="h5" component="h1"   >
                                          <CountUp end={54210} duration={1} enableScrollSpy />
                                      </Typography>
                                  </Box>
                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'danger.light', color: 'danger.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          First mile agent
                                      </Typography>
                                      <Typography variant="h5" component="h1"   >
                                          <CountUp end={54210} duration={1} enableScrollSpy />
                                      </Typography>
                                  </Box>
                              </Stack>


                          </CardContent>

                      </Card>
  </div>
);

export default WarningMessages;